





































































































































































import { Component, Vue, Watch, Ref } from "vue-property-decorator";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { IFaixaPercentual, FaixaPercentualDTO} from "@/models/solicitacoes/FaixaPercentualServicosModel";
import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";
import { ValidationObserver } from "vee-validate";

@Component({
  components: {
    GsModalDialog,
  },
})
export default class FaixaDePreco extends Vue {
  @Ref()
  filtroObserver!: InstanceType<typeof ValidationObserver>;

  valores: FaixaPercentualDTO[] = [];
  loading = false;
  cabecalho = [
      { text: "Km Inicial", value: "kmInicial", width: "20%" },
      { text: "Km Final", value: "kmFinal", width: "20%" },
      { text: "Percentual", value: "percentual", width: "20%" },
      { text: "Ações", value: "actions", width: "15%", sortable: false }
  ];
  salvarFaixa: FaixaPercentualDTO = {
    id: 0,
    kmInicial: 0,
    kmFinal: 0,
    percentual: 0
  };
  valorPercentual: IFaixaPercentual = { 
    id: 0, 
    kmInicial: undefined,
    kmFinal: undefined,
    percentual: undefined
  };

  dialogType = "sucess";
  showDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  desabilidaPercentual = true;

  alterarConfiguracao(IFaixaPercentual: IFaixaPercentual) {
    this.valorPercentual = Object.assign({}, IFaixaPercentual);
    this.desabilidaPercentual = false;
  }

  beforeMount() {
    this.obterFaixaDePreco();
  }

  obterFaixaDePreco() {
    this.loading = true;
    this.valores = [];
    ServicosAssistenciaService
    .obterFaixaPercentual(
      ).then((res: FaixaPercentualDTO[]) => {
          this.valores = res;
          this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
      });
  }

  salvarFaixaDePreco() {
    let valid = true;  
   
    if (!this.valorPercentual.kmInicial) {
      this.filtroObserver.setErrors({
        KmInicial: "O campo Km Inicial é obrigatório",
      });
      valid = false;
    }
    if (!this.valorPercentual.kmFinal) {
      this.filtroObserver.setErrors({
        KmFinal: "O campo Km Final é obrigatório",
      });
      valid = false;
    }
    if (!this.valorPercentual.percentual) {
      this.filtroObserver.setErrors({
        Percentual: "O campo Percentual é obrigatório",
      });
      valid = false;
    }
    if(!valid) { 
      return;
    }  
      
    this.salvarFaixa.id = this.valorPercentual.id;
    this.salvarFaixa.kmInicial = this.valorPercentual.kmInicial;
    this.salvarFaixa.kmFinal = this.valorPercentual.kmFinal;
    this.salvarFaixa.percentual = this.valorPercentual.percentual;

    ServicosAssistenciaService
    .salvarFaixaPercentual(
    this.salvarFaixa
    ).then(() => {
    this.resetValorFaixaConcerto()
    this.openDialog('success', "Operação realizada com sucesso", "Operação realizada com sucesso");
    })
    .catch((err: any) => {
        console.log(err);
        this.openDialog('error', 'Erro ao realizar a inclusão da faixa.', err.message);
    });
}

  resetValorFaixaConcerto() {
    this.valorPercentual.id = 0;
    this.valorPercentual.kmInicial = undefined;
    this.valorPercentual.kmFinal = undefined;
    this.valorPercentual.percentual = undefined;
    this.obterFaixaDePreco();
    this.desabilidaPercentual = true;
  }

  realizarExclusao(FaixaPreco: IFaixaPercentual) {
    ServicosAssistenciaService.excluirFaixaPercentual(FaixaPreco.id)
    .then(() => {
      this.obterFaixaDePreco();  
      this.openDialog('success', "Exclusão da faixa efetuada com sucesso.", "Exclusão da faixa efetuada com sucesso.");
    })
    .catch(() => {
       this.openDialog('error', 'Erro ao realizar a exclusão da faixa.', 'Erro ao realizar a exclusão da faixa.');
    })
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "warning";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }
}
